import { createSlice } from "@reduxjs/toolkit";

const initialState =  {
      gameOver: false,
    };

const xoGameOverSlice = createSlice({
  name: "xoGameOverSlice",
  initialState: initialState,
  reducers: {
    setGameOver: (state, action) => {
      state.gameOver = true;
      return state;
    },
    resetGameOver: (state, action) => {
      state.gameOver = false;
      return state;
    },
  },
});

export const { setGameOver, resetGameOver } = xoGameOverSlice.actions;
export default xoGameOverSlice;